<div class="row">
  @for (room of listRooms; track room.id) {
    <div class="col-sm-6 col-lg-4">
      <app-item-room [room]="room"></app-item-room>
    </div>
  }
</div>
